module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "become-an-affiliate-success",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    class: [{
      'zh-style': _vm.language === 'zh'
    }, 'modal-dialog'],
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content text-center"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', [_c('svg', {
    staticClass: "icon"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-close"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('thanksInfo'))), _c('br'), _vm._v(_vm._s(_vm.$t('successNotice'))), _c('span', [_vm._v("iplexservice@gmail.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v(_vm._s(_vm.$t('sure')))])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10aa53ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/becomeAffiliate/successModal/Index.vue
// module id = 1263
// module chunks = 1